import {MOBILE_PREFIX_PATH} from "../../configs/AppConfig";
import {useNavigate} from "react-router-shim";
import MobPressable from "./MobPressable";

export function MobCard({inner,children,style,onClick})
{

    return(
        <MobPressable style={{backgroundColor:inner?"#F3F2F7":"#FFF",padding:"8px",boxShadow:inner?"none":"0px 1px 5px rgba(0,0,0,0.2)",borderRadius:10,...style}} onClick={onClick}>
            {children}
        </MobPressable>
    )
}
